export default __webpack_public_path__ + "static/media/pub_pizza.0f97f3bf.jpg";